import { ButtonSelectorComponent } from './button-selector.component';

declare let angular: ng.IAngularStatic;

export default angular
  .module('sfMobile.components.button-selector', [])
  .component('sfButtonSelector', ButtonSelectorComponent).name;
